export default __webpack_public_path__ + "static/media/2966669.3b84ccff.jpeg";